export default "__VITE_ASSET__BrU$RR_u__"